export default __webpack_public_path__ + "static/media/guide10.dcad055d.png";